
const Markdown = (props: {input:any}) => {
    const {input} = props;
    return (
        <div className="markdown" dangerouslySetInnerHTML={{__html:input}}></div>
    )
}

export default Markdown;